import { createSlice } from "@reduxjs/toolkit";

export const DetailIdSlice = createSlice({
  name: "Detail Id",
  initialState: {
    detailIds: {
      serviceCategoryId: "",
      productId: "",
      productPageType: "add",
      packageId: "",
      userPackageId: "",
    },
  },
  reducers: {
    setDetailIds: (state, action) => {
      state.detailIds = action.payload;
    },
    setProductId: (state, action) => {
      state.detailIds.productId = action.payload;
    },
    setProductPageType: (state, action) => {
      state.detailIds.productPageType = action.payload;
    },
  },
});

export const { setDetailIds, setProductPageType, setProductId } = DetailIdSlice.actions;

export default DetailIdSlice.reducer;
